import {yupResolver} from "@hookform/resolvers/yup";
import {useState} from "react";
import {Modal} from "react-bootstrap";
import {useForm} from "react-hook-form";
import {postService} from "../../../services/post.service";
import {Toast} from "../../../utils/Toast";
import {ISharePostModal} from "../../organisations/createorganisation/interfaces/share-post-modal.interface";
import {sharePostSchema} from "../../organisations/createorganisation/validations/share-post.validation";
import {useTranslation} from "react-i18next";

export const SharePostOrganizationModal: React.FC<ISharePostModal> = (props) => {
    const [isLoading, setIsloading] = useState(false);
    const { t } = useTranslation('', { keyPrefix: 'SharePostOrganizationModal' });

    const { register: shareRegister, handleSubmit: shareSubmit, formState: { errors: shareErrors }, reset: shareReset } = useForm<any>({
        resolver: yupResolver(sharePostSchema)
    });
    const sharePostSubmit = async (data: any) => {
        setIsloading(true)
        if (data.organization == '0') {
            Toast.fire({
                icon: 'warning',
                title: t('pleaseSelectOrganisation')
            })
            return;
        }
        const res: any = await postService.sharePost({
            "content": props.postToBeShared?.content,
            "mediaType": props.postToBeShared?.mediaType,
            "medias": props.postToBeShared?.medias,
            "allowComment": props.postToBeShared?.allowComment,
            "allowShare": props.postToBeShared?.allowShare,
            "organization": data.organization,
            "postedBy": props.postToBeShared.creator._id,
            "displayTo": props.postToBeShared?.displayTo
        })
        if (res.statusCode === 201) {
            shareReset({ organization: '' });
            props.closeModal(true)
        setIsloading(false)

            Toast.fire({
                icon: 'success',
                title: res.message
            })
        } else {
        setIsloading(false)
            Toast.fire({
                icon: 'warning',
                title: res.message
            })
        }
    }
    const closeShareModal = ( ) => {
        props.closeModal(true)
    }
    return <Modal className="up-thememodal up-modalcreateupdates" show={true} onHide={closeShareModal}>
        <Modal.Header className="up-modalheader" closeButton>
            <Modal.Title>{t('sharePost')}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="up-modalbody">
            <div className="up-modalcontentholder">
                <form className="up-formtheme up-formcreategroup" onSubmit={shareSubmit(sharePostSubmit)}>
                    <fieldset>
                        <div className="up-creategroupcontentholder" style={{ paddingTop: '0px' }}>
                            <div className="up-sharemodalcontent">
                                <div className="form-group">
                                    <label>{t('selectOrganizationName')}</label>
                                    <span className="up-select">
                                        <select {...shareRegister('organization')} name="organization" className="form-control">
                                            {props.userOrganizations && props.userOrganizations.map((e, key) => {
                                                return <option key={key} value={e._id}>{e.name}</option>;
                                            })}
                                        </select>
                                    </span>
                                    <small id="emailHelp" className="form-text text-muted">
                                        {shareErrors.organization?.message}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <button disabled={isLoading} type="submit" className="up-btn up-btn-lg">{t('share')} {isLoading && <div className="lds-dual-ring"></div>}</button>
                    </fieldset>
                </form>
            </div>
        </Modal.Body>
    </Modal>
}